import { useQuery } from "react-query";
// components
import Card from "../../components/cards/Card.jsx";
//services
import { getGraphics } from "../../services/Dashboard/getGraphics.js";
//utils
import { formatCurrency } from "../../utils/formatCurrency.js";
import { useAppContext } from "../../context/AppContext.jsx";

const InfoCards = () => {
  const { permissions } = useAppContext();
  const { data: valueToPay } = useQuery("valueToPay", () =>
    getGraphics("bills_to_pay"),
    {
      enabled: !!permissions?.includes("5")
    }
  );

  const { data: valueToReceive } = useQuery("valueToReceive", () =>
    getGraphics("accounts_to_receive"),
    {
      enabled: !!permissions?.includes("5")
    }
  );

  const { data: nonPaymentTotal } = useQuery("nonPaymentTotal", () =>
    getGraphics("non_payment_total"),
    {
      enabled: !!permissions?.includes("5")
    }
  );

  return (
    <>
      <Card
        title="Contas a Pagar Geral"
        value={valueToPay && formatCurrency(valueToPay.bills_to_pay)}
        size="col-xl-4 col-md-12"
        desc="Total do Mês (em aberto)"
        class={"widget widget-stats bg-indigo pb-0 mb-2"}
        icon={<i className="fa fa-money-bill-1 fa-fw"></i>}
      />
      <Card
        title="Contas a Receber Geral"
        value={
          valueToReceive && formatCurrency(valueToReceive.accounts_to_receive)
        }
        size="col-xl-4 col-md-12"
        desc="Total do Mês (em aberto)"
        class="widget widget-stats bg-blue pb-0 mb-2"
        icon={<i className="fa fa-dollar-sign fa-fw"></i>}
      />
      <Card
        title="Inadimplência Total"
        value={nonPaymentTotal && formatCurrency(nonPaymentTotal.non_payment)}
        size="col-xl-4 col-md-12"
        desc="Total Inadimplência (Sem Multa, Juros)"
        class={"widget widget-stats bg-black bg-opacity-75 pb-0 mb-2"}
        icon={<i className="fa fa-gavel fa-fw"></i>}
      />
    </>
  );
};

export default InfoCards;
